module.exports = __webpack_public_path__ + "img/symbol_3.7d07fbf5.png";